import { Eye, EyeOff } from 'lucide-react';
import { useState, type ComponentProps } from 'react';

import { Button, Input, cn } from '@shigo-ui/ui';

import { dashboardT } from '../../../../lib/messages';

type AuthPasswordInputProps = Omit<ComponentProps<typeof Input>, 'type'>;

export function AuthPasswordInput({ className, ...props }: AuthPasswordInputProps) {
  const [visible, setVisible] = useState(false);
  const toggleLabel = dashboardT(visible ? 'auth.login.hidePassword' : 'auth.login.showPassword');

  return (
    <div className="relative">
      <Input
        {...props}
        className={cn('h-11 rounded-lg bg-transparent pr-11 text-[15px]', className)}
        type={visible ? 'text' : 'password'}
      />
      <Button
        aria-label={toggleLabel}
        className="text-muted-foreground hover:text-foreground absolute inset-y-0 right-2 my-auto h-7 w-7 hover:bg-transparent"
        onClick={() => {
          setVisible((current) => !current);
        }}
        size="icon"
        type="button"
        variant="ghost"
      >
        {visible ? (
          <EyeOff className="h-4 w-4" aria-hidden="true" />
        ) : (
          <Eye className="h-4 w-4" aria-hidden="true" />
        )}
      </Button>
    </div>
  );
}
